import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import { getDomains } from '../DomainAdmin/store/DomainAdminSelectors'
import SsoAdmin, { ISsoAdminProps, ISsoAdminDispatchProps } from './SsoAdmin'
import {
  getCompanySsoConfigs,
  getCompanySsoConfig,
  createCompanySsoConfig,
  updateCompanySsoConfig,
  deleteCompanySsoConfig,
  enableScim,
  disableScim,
  regenerateScimToken,
  getCompanySsoSettings,
  updateCompanySsoSettings,
} from './store/SsoAdminActions'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { getCompanyDomains } from '../DomainAdmin/store/DomainAdminActions'
import {
  getSsoConfigs,
  getSelectedSsoConfig,
  getSsoLoading,
  getSsoSaving,
  getSsoDeleting,
  getCreatedConfigId,
  getScimConfig,
  getScimTokenVisible,
  getScimSaving,
  getSsoRequired,
  getSsoSettingsUpdating,
} from './store/SsoAdminSelectors'

const mapStateToProps = (state: IGlobalState): ISsoAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  configs: getSsoConfigs(state),
  selectedConfig: getSelectedSsoConfig(state),
  loading: getSsoLoading(state),
  saving: getSsoSaving(state),
  deleting: getSsoDeleting(state),
  createdConfigId: getCreatedConfigId(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
  scimConfig: getScimConfig(state),
  scimTokenVisible: getScimTokenVisible(state),
  scimSaving: getScimSaving(state),
  domains: getDomains(state),
  ssoRequired: getSsoRequired(state),
  ssoSettingsUpdating: getSsoSettingsUpdating(state),
})

const mapDispatchToProps: ISsoAdminDispatchProps = {
  getCompanySsoConfigs,
  getCompanySsoConfig,
  createCompanySsoConfig,
  updateCompanySsoConfig,
  deleteCompanySsoConfig,
  setSsoSelectedCompanyId: setCompanyAdminSelectedCompanyId,
  enableScim,
  disableScim,
  regenerateScimToken,
  getCompanyDomains,
  getCompanySsoSettings,
  updateCompanySsoSettings,
}

export default connect(mapStateToProps, mapDispatchToProps)(SsoAdmin)
